import React, { useState, useEffect, useRef } from "react";
import IOSInstructions from "./IOSInstructions";
import AndroidInstructions from "./AndroidInstructions";
import DesktopInstructions from "./DesktopInstructions";
import { Button, Drawer as AntDrawer, Flex, Image } from "antd";
import { isIOS, isAndroid, isPc } from "src/util/device.util";
import styled from "styled-components";

const Drawer = styled(AntDrawer)`
  padding-bottom: 4rem;
`;

const LogoContainer = styled(Flex)`
  margin-block: 3rem;
  justify-content: center;
`;

const InstallBar = styled.div`
  color: white;
  background-color: #d61456;
  width: 100%;
  box-sizing: border-box;
  padding: 1rem;
  right: 0;
  top: 3.5rem;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

type PwaEvent = {
  prompt?: () => {};
} & Event;

function PWADrawer() {
  const [pwaDrawerShow, setPwaDrawerShow] = useState(false);
  const [installEvent, setInstallEvent] = useState<PwaEvent | null>(null);
  useEffect(() => {
    if (!("standalone" in window.navigator && window.navigator.standalone))
      setPwaDrawerShow(true);
    window.addEventListener("beforeinstallprompt", (e) => {
      const event: PwaEvent = e;
      e.preventDefault();
      setInstallEvent(event);
    });
  }, []);
  const installWait = async () => {
    installEvent?.prompt && installEvent?.prompt();
  };

  return (
    <Drawer
      placement="bottom"
      onClose={() => setPwaDrawerShow(false)}
      open={pwaDrawerShow}
      height="unset"
    >
      {installEvent && (
        <InstallBar>
          <span>با نصب نیتا از تمام امکانات آن استفاده .</span>
          <Button onClick={installWait}>Install</Button>
        </InstallBar>
      )}
      <LogoContainer>
        <Image
          preview={false}
          src="/image/Logo-mark.png"
          width={94}
          height={94}
        />
      </LogoContainer>
      {isIOS && <IOSInstructions />}
      {isAndroid && <AndroidInstructions />}
      {isPc && <DesktopInstructions />}
    </Drawer>
  );
}

export default PWADrawer;
